import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { searchAtom } from '@/store/app/AppAtom'
import { searchDocsAtom } from '@/store/documents/DocumentsAtom'

import Search from './Search'

const Container = ({
    location,
    placeholder = 'Search...',
}: {
    location?: 'chatHistory' | 'docsHistory' | 'searchDocs' | 'searchLangs'
    placeholder?: string
}) => {
    const [generalSearch, setGeneralSearch] = useAtom(searchAtom)
    const [searchDocs, setSearchDocs] = useAtom(searchDocsAtom)

    const onSearch = (searchItem: string) => {
        if (location === 'searchDocs') {
            setSearchDocs(searchItem)
        } else {
            setGeneralSearch(searchItem)
        }
    }

    useEffect(() => {
        return () => {
            location === 'searchDocs' && setSearchDocs('')
            location !== 'searchDocs' && setGeneralSearch('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Search placeholder={placeholder} searchWord={location === 'searchDocs' ? searchDocs : generalSearch} onSearch={onSearch} />
}

export default Container
